<template>
  <v-card class="my-1" elevation="0" style="height: 49%;">
    <v-card-title>
      <h5>Contribuição Ponderada ao ISFP (Top 10)</h5>
    </v-card-title>
    <div
      v-if="loading"
      class="d-flex align-center justify-center"
      style="height: 70px;"
    >
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>
    <v-card-text v-else>
      <highcharts :options="chartOptions" :deepCopyOnUpdate="false" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "DashboardIsfpPsfpContribuicaoIsfpGeral",
  props: {
    contribuicao: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  computed: {
    chartOptions() {
      const dados = this.contribuicao;

      const coresPorFaixa = {
        ate_1: "#4CAF50",
        de_1_a_5: "#8BC34A",
        de_5_a_10: "#FFC107",
        de_10_a_20: "#FF9800",
        acima_20: "#F44336",
      };

      return {
        chart: { type: "column", height: 350 },
        credits: { enabled: false },
        title: { text: null },
        legend: { enabled: false },
        xAxis: {
          categories: dados.map((d) => d.indice_categoria),
          crosshair: true,
          labels: { style: { fontSize: "13px" } },
        },
        yAxis: {
          title: { text: null },
          labels: { style: { fontSize: "13px" } },
        },
        tooltip: {
          formatter() {
            const d = dados[this.point.index];
            return (
              `<b>${d.indice_categoria} - ${d.descricao_por_indice}</b><br/>` +
              `Contribuição: ${d.contribuicao_ponderada_isfp} p.p.<br/>` +
              `<span style="color:#999">PSFP: ${d.psfp}%</span><br/>` +
              `<span style="color:#999">SA: ${d.sa}</span>`
            );
          },
        },
        plotOptions: {
          column: {
            dataLabels: { enabled: false },
          },
        },
        series: [
          {
            name: "Contribuição Ponderada",
            animation: false,
            data: dados.map((d) => ({
              y: d.contribuicao_ponderada_isfp,
              color: coresPorFaixa[d.faixa_chave],
            })),
          },
        ],
        lang: { noData: "Sem dados para exibição" },
      };
    },
  },
};
</script>
